import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Line } from 'react-chartjs-2';
import dayjs from 'dayjs';
import colors from 'theme/colors';

export default function SoldByDayChart({ data = [], label, emptyText }) {
    const chartData = useMemo(() => ({
        labels: data.map((el) => dayjs(el.date).format('DD/MM')),
        datasets: [
            {
                label,
                data: data.map((el) => el.sold),
                backgroundColor: 'rgba(128, 37, 232, 0.12)',
                borderColor: colors.secondaryPurple,
                borderWidth: 2,
                fill: true,
                tension: 0.35,
                pointRadius: 3,
                pointBackgroundColor: colors.secondaryPurple,
                pointHoverRadius: 5,
                pointHitRadius: 8,
            },
        ],
    }), [data, label]);

    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    fontColor: '#999',
                    fontSize: 12,
                    precision: 0,
                },
                gridLines: { color: '#f0f0f0', drawBorder: false },
            }],
            xAxes: [{
                ticks: {
                    fontColor: '#999',
                    fontSize: 11,
                    maxRotation: 0,
                    autoSkip: true,
                    maxTicksLimit: 10,
                },
                gridLines: { display: false },
            }],
        },
        legend: { display: false },
        tooltips: {
            backgroundColor: '#1A1A1A',
            cornerRadius: 8,
            xPadding: 12,
            yPadding: 10,
            callbacks: {
                label: (tooltipItem) => ` ${label}: ${tooltipItem.yLabel}`,
            },
        },
    }), [label]);

    if (!data.length) {
        return <EmptyState>{emptyText}</EmptyState>;
    }

    return (
        <ChartWrap>
            <Line data={chartData} options={options} />
        </ChartWrap>
    );
}

const ChartWrap = styled.div`
    height: 260px;
    width: 100%;
`;

const EmptyState = styled.p`
    margin: 0;
    padding: 28px 0;
    text-align: center;
    font-size: 13px;
    color: ${colors.night};
`;
